import React from 'react';

export const Divider: React.FC = () => {
  return (
    <>
      <span
        style={{
          width: 1,
          height: 36,
          backgroundColor: '#E8E8E8',
        }}
      />
    </>
  );
};
